<div class="region-page-container">
    <app-page-title>
        <h1>Nézz szét a környéken</h1>
        <h2>Fedezd fel a környék különleges hangulatát és csodás szépségét!</h2>
    </app-page-title>
    <div class="region-page-body-container">
        <div class="region-container">
            <section class="section region-summary">
                <h3>Szajki-tavak</h3>
                <p>
                    A Szajki-tavak egy láncszerű, részben emberi beavatkozással kialakult tóvidék a korábbi
                    Csörgető-patak mentén. Kezdetben két kisebb természetes tó és egy malom volt itt; a 20. század
                    elején indultak meg az átalakítási tervek, amelyek a mai, fásított partokkal övezett tórendszert
                    hozták létre. A területet gyakran emlegetik „ember alkotta természetcsodaként”.
                </p>

                <p>
                    A tavak többcélúak: egyes részeket haltenyésztésre és horgászatra tartanak fenn, míg a középső
                    tó (a strandtó) a fürdőzők és pihenni vágyók számára szolgál. A környék a 60–70-es években vált
                    üdülőövezetté, majd fokozatosan fejlődött a strand, a közművek és a parkrendszer. Az elmúlt
                    évtizedek beruházásai (például akadálymentesített strand) tovább növelték a terület vonzerejét.
                </p>

                <ul>
                    <li>Természeti érték: fásított partok, változatos vízfelületek.</li>
                    <li>Szolgáltatások: horgászat, fürdőzés, sportpályák, játszóterek, vizesblokkok.</li>
                    <li>Célközönség: családok, horgászok és kirándulók.</li>
                </ul>
            </section>

            <section class="section region-beach right">
                <h3>Szajki-tavak strand (6-os tó)</h3>
                <p>
                    A 6-os számú tó a fürdőzni vágyók fő helyszíne: a tó körül kialakított partszakasz és füves területek
                    kényelmes pihenési lehetőséget biztosítanak. A strand partszakasza kb. 200 m hosszú, többfunkciós
                    pihenő- és sportterülettel (futball, röplabda, pingpong, játszótér).
                </p>

                <p>
                    A fejlesztések során homokos partszakasz, korszerű bejárat és felújított vizesblokkok készültek. A tó
                    kiváló lehetőséget nyújt vízibiciklizésre, csónakázásra és kajakozásra is.
                </p>

                <p class="note">
                    Röviden: a Szajki-tavak egyszerre kínál nyugalmat, aktív kikapcsolódást és természeti élményt —
                    könnyen elérhető üdülőhely minden korosztálynak.
                </p>

                <div class="download-container">
                    <app-button class="btn btn-primary" [size]="'large'" [text]="'Látnivalók (PDF) letöltése'" (buttonClick)="downloadPdf()"></app-button>
                </div>
            </section>
        </div>
    </div>
</div>